import React from 'react'
import './about.css'
import ME from '../../assets/me1.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
import {BiWorld} from 'react-icons/bi'


 const About = () => {
  return (
    <section id='about'>
      <h5>Conheça mais</h5>
      <h2>Sobre Mim</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
          <img src={ME} alt="About"/>
          </div>
        </div>


      <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className='about__icon'/>
              <h5>Experiência</h5>
              <small>2+ na área</small>
            </article>

            <article className="about__card">
              <FiUsers className='about__icon'/>
              <h5>Clientes</h5>
              <small>5+ Locais</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className='about__icon'/>
              <h5>Projetos</h5>
              <small>10+ feitos</small>
            </article>
            <article className="about__card">
              <BiWorld className='about__icon'/>
              <h5>Línguas</h5>
              <small>Português e Inglês</small>
            </article>
            </div>
          <p>Olá, seja bem vindo! Eu sou um desenvolvedor apaixonado, especializado na criação
              de aplicativos multiplataforma integrados. Com uma base sólida em tecnologias front-end e back-end, 
              me esforço para construir soluções intuitivas e eficientes. 
              Fora da programação gosto de explorar novas tendências tecnológicas como redes de computadores, 
              cibersegurança e design web, e trabalhar em projetos inovadores. 
            </p>

            <a href='#contact' className='btn btn__primary'>Entre Em Contato</a>
      
      </div>
      </div>
    </section>
  )
}

export default About